"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEditor = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var useEditor = function useEditor(props) {
  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      editorRef = _useState2[0],
      setEditorRef = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      editorInstance = _useState4[0],
      setEditorInstance = _useState4[1];

  var setRef = function setRef(ref) {
    return ref && setEditorRef(function (prev) {
      return prev || ref;
    });
  };

  (0, _react.useEffect)(function () {
    if (editorRef) {
      setEditorInstance(editorRef.editorInstance);
      var observer = new MutationObserver(function () {
        if (editorRef && editorRef.editorInstance) {
          setEditorInstance(_objectSpread({}, editorRef.editorInstance));
        }
      });
      observer.observe(editorRef.dom, {
        attributes: true,
        childList: true,
        subtree: true
      });
      return function () {
        return observer.disconnect();
      };
    }

    return function () {
      return null;
    };
  }, [editorRef]);
  var editorProps = (0, _react.useMemo)(function () {
    return _objectSpread(_objectSpread({}, props), {}, {
      ref: setRef
    });
  }, [props]);
  return [editorProps, editorInstance];
};

exports.useEditor = useEditor;